import { Banner } from './types';

export const isValidBanner = (banner: Banner | null | undefined): boolean => {
  return (
    banner !== null &&
    banner !== undefined &&
    Object.keys(banner).length > 0 &&
    !!banner.messages &&
    typeof banner.id === 'string' &&
    (banner.type === 'business' || banner.type === 'technical')
  );
};
